import { render, staticRenderFns } from "./Regionales.vue?vue&type=template&id=07f4bc65&"
import script from "./Regionales.vue?vue&type=script&lang=js&"
export * from "./Regionales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports